import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { ProductProviderFormView } from './product-provider-form.view';
import { ProductProviderDataService } from '../product-provider.data';

interface ProductProviderFormParams {
    id: string
}

@observer
export class ProductProviderFormController extends React.Component<ControllerProps<ProductProviderFormParams>, any>  {

    @observable
    protected dataService: ProductProviderDataService;

    @resolve
    protected configurationService: ConfigurationService;

    @computed
    protected get title() {
        if (this.dataService && this.dataService.item) {
            return `Product Provider ${this.dataService.item.name || ''}`;
        }
        return '';
    }

    @resolve
    protected toast: ToastNotifications;

    constructor(props) {
        super(props);
        this.state = { mode: 'display' }
    }


    @autobind
    protected onModeChanged(mode: ControlMode) {
        this.setState({ mode: mode });
    }

    @autobind
    public async save() {
        const item = this.dataService.item;
        const errors = await item.validate(true);
        if (errors.length == 0) {
            this.props.setBusy(true);

            this.dataService.save()
                .then(() => {
                    this.props.setBusy(false);
                    this.toast.showDataSaved();
                    this.props.history.replace(`/products/product-providers`);
                })
                .catch((error) => {
                    this.props.setBusy(false);
                    this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
                });
        } else {
            this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
        }
	}

    @autobind
	public cancel(): void {
		this.props.history.push('/products/product-providers');
    }

    componentDidMount() {
        this.dataService = ProductProviderDataService.make();
        this.props.setBusy(true);

        // Load entity
        this.dataService.addFilter('id', 'eq', this.props.match.params.id);
        this.dataService.addSorting('id', 'asc', true);
        this.dataService.pageSize = 1;
        this.dataService.load(query => query)
            .then(item => {
                this.props.setBusy(false);
            }).catch(error => {
                this.props.setBusy(false);
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });

    }

    render() {
        if (this.dataService == null || this.dataService.item == null) {
            return null;
        }

        return (
            <ProductProviderFormView
				title={this.title}
				mode={this.state.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				model={this.dataService.item}
				setBusy={this.props.setBusy}
				contextService={this.dataService}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/form/product-provider-form.controller.tsx